AuthRoute = require 'mixins/authenticated-route'

App.SettingsStaffCreateRoute = Em.Route.extend AuthRoute,
  session: Em.inject.service()
  model: (params) ->
    if @get('session.isLC')
      @store.createRecord('logistics_staff')
    else
      @store.createRecord('staff_member')

  controllerName: 'settingsStaffEdit'
  templateName:   'settings.staff.edit'

  actions:
    willTransition: ->
      controller = @get('controller')
      controller.teardown()

      staff = controller.get('model')
      @store.unloadRecord( staff )
